// extracted by mini-css-extract-plugin
export var container = "_hc-0";
export var content = "_hc-3";
export var customerTitle = "_hc-4";
export var empty = "_hc-5";
export var gray = "_hc-6";
export var header = "_hc-7";
export var info = "_hc-8";
export var loading = "_hc-2";
export var loadingCard = "_hc-9";
export var oneLine = "_hc-a";
export var personName = "_hc-e";
export var pillContainer = "_hc-b";
export var selected = "_hc-1";
export var text = "_hc-c";
export var twoLines = "_hc-d";
export var unread = "_hc-f";
export var unreadIndicator = "_hc-g";